import Toptimize from "./toptimize/index"

new Toptimize({
  // attr: "data-component-assets",
  manifestUrl: `${window.themeVars.templateUri}/assets/dist/manifest.json`,
  cacheVersion: window.themeVars.version,
  assetsRootUrl: `${window.themeVars.templateUri}/assets/dist`,
  observerLandscapeOffset: 0.5, // 0-1 (1 = 100% of the window height) or "200px" (string)
  observerPortraitOffset: 0.2, // 0-1 (1 = 100% of the window height) or "200px" (string)
})
